module.exports = __webpack_public_path__ + "media/images/footer-email-icon-4fb62dd1fedb3587fc04c98e0bfdf6f2.png";